import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

declare var Auth0Lock: any;

@Injectable({ providedIn: 'root' })
export class AuthService {
  private lock = signal<any>(null);

  constructor(private router: Router) {
    this.lock.set(new Auth0Lock(environment.auth0ClientId, environment.auth0Domain, {
      container: 'auth0-lock-container',
      allowedConnections: ['google-oauth2'],
      rememberLastLogin: false,
      auth: {
        responseType: 'token id_token',
        audience: environment.auth0Audience,
        redirectUrl: environment.auth0RedirectUrl,
        params: { scope: 'openid profile email' },
      },
      theme: {
        logo: 'assets/logo.png',
        primaryColor: '#2E1E5B',
      },
      languageDictionary: {
        title: 'Banner Audit',
        loginSubmitLabel: 'Ingresar con Google',
      },
    }));

    this.handleAuthentication();
  }

  showLock(): void {
    this.lock().show();
  }

  private handleAuthentication(): void {
    this.lock().on('authenticated', (authResult: any) => {
      const email: string = authResult.idTokenPayload?.email ?? '';
      const domain = email.split('@')[1] ?? '';

      if (!environment.allowedEmailDomains.includes(domain)) {
        this.lock().show({ flashMessage: { type: 'error', text: 'Acceso no autorizado para este dominio.' } });
        return;
      }

      localStorage.setItem('access_token', authResult.accessToken);
      localStorage.setItem('id_token', authResult.idToken);
      localStorage.setItem('expires_at', JSON.stringify(authResult.expiresIn * 1000 + Date.now()));
      localStorage.setItem('user_email', email);

      this.router.navigate(['/clients']);
    });
  }

  isAuthenticated(): boolean {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at') ?? '0');
    return Date.now() < expiresAt;
  }

  getToken(): string | null {
    return localStorage.getItem('access_token');
  }

  getUserEmail(): string {
    return localStorage.getItem('user_email') ?? '';
  }

  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('user_email');
    this.router.navigate(['/login']);
  }
}
